<template>
  <div
    class="input-wrap"
    :class="{
      'is-row': layout && layout === 'row',
      'is-transparent': isTransparent
    }">
    <label v-if="label" :for="id">{{label}}</label>
    <div class="select__dropdown"
      :disabled="disabled"
      :readonly="readonly">
      <select
        :id="id"
        :name="name"
        v-model="localValue"
        @change="update"
        :required="required"
        :disabled="disabled"
      >
        <option v-if="placeholder" disabled value="null">{{placeholder}}</option>
        <option v-for="option in localOptions" :key="option.key" :value="option.value">
          {{option.label}}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectInput',
  props: {
    id: String,
    name: String,
    value: [String, Boolean],
    options: Array,
    label: String,
    placeholder: String,
    required: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    layout: String,
    isTransparent: Boolean,
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(val) {
      if (val !== this.localValue) {
        this.localValue = val;
      }
    },
  },
  computed: {
    localOptions() {
      const isObject = option => typeof option === 'object';
      const getKey = option => (
        isObject(option) ? option.key : option
      );
      const getValue = option => (
        isObject(option) ? (option.value || option.key) : option
      );
      const getLabel = option => (
        isObject(option) ? (option.label || option.key) : option
      );
      return this.options && this.options.map(option => ({
        key: getKey(option),
        value: getValue(option),
        label: getLabel(option),
      }));
    },
  },
  methods: {
    update() {
      if (this.value !== this.localValue) {
        this.$emit('input', this.localValue);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/input.scss';

</style>
